import { Directive, Input, TemplateRef, ViewContainerRef, effect, EmbeddedViewRef } from '@angular/core';
import { PermisosService } from '../../../features/admin/user-management/services/permisos.service';


@Directive({
  selector: '[tienePermiso]',
  standalone: true,
})
export class TienePermisoDirective {

  @Input('tienePermiso') permisoClave!: string;

  private view: EmbeddedViewRef<any> | null = null;

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly permisosService: PermisosService
  ) {

    // ⚡ El effect DEBE ir en el constructor (esto arregla NG0203)
    effect(() => {
      const permisos = this.permisosService.permisos();
      this.actualizarVista(permisos);
    });

  }

  private actualizarVista(permisos: any): void {
    const permitido =
      permisos &&
      (permisos[this.permisoClave] === true ||
        permisos[this.permisoClave] === 1);

    if (permitido) {
      if (!this.view) {
        this.view = this.viewContainer.createEmbeddedView(this.templateRef);
        this.applyFadeIn();
      }
    } else {
      this.viewContainer.clear();
      this.view = null;
    }
  }

  private applyFadeIn(): void {
    if (!this.view) return;

    this.view.rootNodes.forEach((node: any) => {
      if (node instanceof HTMLElement) {
        node.style.opacity = '0';
        node.style.transition = 'opacity 300ms ease-in';
        setTimeout(() => (node.style.opacity = '1'), 10);
      }
    });
  }
}
